import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class ForceIndex2AvgsTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const fiValue = currentItem && yAccessor(currentItem);

    const m1 = fiValue && fiValue.m1;
    const m2 = fiValue && fiValue.m2;

    const m1Display = (isDefined(m1) && displayFormat(m1)) || "n/a";
    const m2Display = (isDefined(m2) && displayFormat(m2)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const m1Color = appearance?.strokeM1?.color || "#FF0000";
    const m2Color = appearance?.strokeM2?.color || "#00BFFF";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-force-index2-avgs"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Force Index (</ToolTipTSpanLabel>
          <tspan fill={m1Color}>{options.m1Period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={m2Color}>{options.m2Period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>)</ToolTipTSpanLabel>
        </ToolTipText>
        <ToolTipText x={0} y={15} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>M1: </ToolTipTSpanLabel>
          <tspan fill={m1Color}>{m1Display}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> M2: </ToolTipTSpanLabel>
          <tspan fill={m2Color}>{m2Display}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

ForceIndex2AvgsTooltip.propTypes = {
  className: PropTypes.string,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  displayValuesFor: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    strokeM1: PropTypes.shape({ color: PropTypes.string }),
    strokeM2: PropTypes.shape({ color: PropTypes.string }),
  }),
  options: PropTypes.shape({
    m1Period: PropTypes.number.isRequired,
    m2Period: PropTypes.number.isRequired,
  }).isRequired,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
};

ForceIndex2AvgsTooltip.defaultProps = {
  className:
    "react-stockcharts-tooltip react-stockcharts-force-index-2avgs-tooltip",
  displayFormat: format(",.0f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
  labelFill: "#4682B4",
  textFill: "#000000",
};

export default ForceIndex2AvgsTooltip;
